import { useEffect, useRef } from 'react';

import { Label, InputLabel,  } from './styled'

const Component = ({
    type,
    name,
    label,
    flexGrow,
    readOnly,
    variant,
    formik,
    placeholder,
    labelColor,
    isTextArea
}) => {
    const textAreaRef = useRef(null);

    useEffect(() => {
        if (isTextArea && textAreaRef.current) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
        }
    }, [formik.values[name]]);

    return (
        <InputLabel className={flexGrow ? flexGrow : null}>
            <Label color={labelColor}>
                <label htmlFor={name}>{label}</label>
                <div>
                    {formik.touched[name] && formik.errors[name] ?
                        formik.errors[name] :
                        null}
                </div>
            </Label>

            {isTextArea ? (
                <textarea
                    id={name}
                    ref={textAreaRef}
                    name={name}
                    readOnly={readOnly}
                    className={variant}
                    placeholder={placeholder}
                    value={formik.values[name]}
                    onChange={formik.handleChange}
                    style={{ overflow: 'hidden', resize: 'none' }}
                />
            ) : (
                <input
                    type={!type ? 'text' : type}
                    id={name}
                    name={name}
                    readOnly={readOnly}
                    className={variant}
                    placeholder={placeholder}
                    value={formik.values[name]}
                    onChange={formik.handleChange}
                />
            )}
        </InputLabel>
    )
}

export default Component
